import {EmailOutlined} from "@mui/icons-material";
import {Alert, IconButton, Slide, Snackbar, Tooltip} from "@mui/material";
import {useState} from "react";
import {webappName} from "../js/AppRoutes.js";
import {red_900} from "../js/APXTheme.js";


export default function APXPlusContactDeveloper() {
	  const scheme = "mailto:";
	  const email = "apxdgtl@gmail.com";
	  const subject = `?subject=Top-priority email from patron of ${webappName}+`;
	  const text = scheme + email + subject;
	  const successMessage = "Email copied to clipboard";
	  const [open, setOpen] = useState(false);
	  return (
				 <>
						<Tooltip title={"Contact Developer"}>
							  <IconButton size={"large"} color={"primary"}
											  onClick={() => navigator.clipboard.writeText(text).then(() => setOpen(true))}>
									 <EmailOutlined/>
							  </IconButton>
						</Tooltip>
						<Snackbar open={open} autoHideDuration={1000}
									 onClose={() => setOpen(false)}
									 anchorOrigin={{vertical: "bottom", horizontal: "center"}}
									 TransitionComponent={Slide}
						>
							  <Alert variant={"filled"} sx={{m: 2, alignItems: "center", justifyContent: "center", color: "#000", backgroundColor: red_900}}>
									 {successMessage}
							  </Alert>
						</Snackbar>
				 </>
	  );
}